import React, { useEffect, useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { server } from "../../../common";
import { loginStudent } from "../../../store/actions";
import { useContext } from "react";
import configContext from "../../../context/configContext/configContext";

const initialValues = {
  email: "",
  password: "",
};

const LoginStudent = () => {
  document.title = "Student Login";
  const [showPassword, setShowPassword] = useState(false);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    values,
    handleBlur,
    touched,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email")
        .required("Please Enter Your Email"),
      password: Yup.string()
        .min(2, "Enter details")
        .required("Please Enter Your password"),
    }),

    onSubmit: (values, action) => {
      setProcessing(true);
      setProgress(10);
      console.log(values);
      server
        .post(
          "/register/studentlogin",
          values,

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              dispatch(loginStudent({ authToken: response.data.token }));
              toast.success("Login successfully");
              navigate("/");
              resetForm();
              setProgress(100);
            }
            setProcessing(false);
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else if (error.response?.data?.error) {
            toast.error(error?.response?.data?.error);
          } else toast.error("Failed to connect to server");
          setProcessing(false);
          setProgress(100);
        });
    },
  });

  return (
    <>
      <section style={{ marginTop: "1rem" }}>
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-10">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className="col-md-6 col-lg-5">
                    <img
                      src="https://gumlet.assettype.com/down-to-earth%2Fimport%2Fdte%2Fuserfiles%2Fimages%2F5-marathwada-farmer.jpg"
                      alt="login form"
                      className="img-fluid"
                      // height={800}
                      // width={450}
                      // className="register_photo"
                      style={{ borderRadius: "1rem 0 0 1rem" }}
                    />
                  </div>
                  <div className="col-md-6 col-lg-7 d-flex align-items-center">
                    <div className="card-body p-4 p-lg-5 text-black">
                      <div>
                        {/* <div className="d-flex align-items-center mb-3 pb-1">
                          <i
                            className="fas fa-cubes fa-2x me-3"
                            style={{ color: "#ff6219" }}
                          />
                          <span className="h1 fw-bold mb-0">Logo</span>
                        </div> */}
                        <h5
                          className="fw-normal mb-3 pb-3 text-uppercase text-center"
                          style={{ letterSpacing: 1 }}
                        >
                          Citizen Login
                        </h5>
                        <form onSubmit={handleSubmit}>
                          <div className="form-outline mb-2">
                            <TextField
                              name="email"
                              margin="dense"
                              type="text"
                              placeholder="Email"
                              variant="outlined"
                              label="Email Id "
                              value={values.email}
                              onChange={handleChange}
                              fullWidth
                              required
                            ></TextField>
                            {errors.email ? (
                              <p className="text-danger">{errors.email}</p>
                            ) : null}
                          </div>
                          <div className="form-outline mb-2">
                            <TextField
                              name="password"
                              margin="dense"
                              type={showPassword ? "text" : "password"}
                              placeholder="Password"
                              variant="outlined"
                              label="Password"
                              value={values.password}
                              onChange={handleChange}
                              fullWidth
                              required
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={handleTogglePassword}
                                      edge="end"
                                    >
                                      {showPassword ? (
                                        <i className="far fa-eye-slash"></i>
                                      ) : (
                                        <i className="far fa-eye"></i>
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            {errors.password ? (
                              <p className="text-danger">{errors.password}</p>
                            ) : null}
                          </div>
                          <div className="pt-1 mb-4">
                            <button
                              className="banner  p-2 rounded-5 border-0 w-100 text-white text-center"
                              type="submit"
                            >
                              Login
                            </button>{" "}
                          </div>
                        </form>
                        <NavLink
                          className="small"
                          to="/loginstudent/forgetpassword"
                        >
                          Forgot password?
                        </NavLink>
                        <p
                          className="mb-5 pb-lg-2"
                          style={{ color: "#393f81" }}
                        >
                          Don't have an account?{" "}
                          <NavLink to="/studentregister">Register here</NavLink>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginStudent;
